import React from 'react';
import { Link } from 'react-router-dom';
import { site } from '../data/site';
type LogoProps = {
  className?: string;
  imgClassName?: string;
};
export function Logo({
  className = '',
  imgClassName = ''
}: LogoProps) {
  return <Link to="/" className={`inline-flex items-center rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-indigo focus-visible:ring-offset-2 ${className}`} aria-label={`${site.brandName} — home`} data-id="element-90" data-mp="3qaw7x7dz2qhp">
      <img src={site.logoUrl} alt={`${site.brandName} logo`} className={imgClassName || 'h-14 w-auto sm:h-16 lg:h-[4.5rem]'} data-id="element-91" data-mp="rrxjotpbmj6h" />
    </Link>;
}